import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ChevronDown, ChevronRight } from 'lucide-react';
import AdminLayout from '@/components/AdminLayout';

const UserSettings = () => {
  const navigate = useNavigate();
  const [userSettingsOpen, setUserSettingsOpen] = useState(true);

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <h2 className="text-3xl font-bold mb-2" style={{ background: '#FF6600', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              User Settings
            </h2>
            <p className="text-gray-600">Manage users and permissions</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="max-w-2xl mx-auto">
              <div className="mb-6">
                <button
                  onClick={() => setUserSettingsOpen(!userSettingsOpen)}
                  className="w-full flex items-center justify-between p-4 rounded-lg hover:bg-orange-50 transition-colors group"
                >
                  <div className="flex items-center gap-3">
                    <Users className="w-6 h-6 text-orange-600" />
                    <span className="font-semibold text-lg text-gray-800">User Management</span>
                  </div>
                  {userSettingsOpen ? (
                    <ChevronDown className="w-5 h-5 text-gray-400" />
                  ) : (
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                  )}
                </button>

                {userSettingsOpen && (
                  <div className="mt-4 ml-12 space-y-2">
                    <button
                      onClick={() => navigate('/admin/user-settings/create')}
                      className="w-full text-left p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-orange-500 hover:bg-orange-50 transition-colors group"
                    >
                      <p className="font-medium text-gray-700 group-hover:text-orange-600">Create User</p>
                      <p className="text-sm text-gray-500 mt-1">Add a new user to the system</p>
                    </button>

                    <button
                      onClick={() => navigate('/admin/user-settings/list')}
                      className="w-full text-left p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-orange-500 hover:bg-orange-50 transition-colors group"
                    >
                      <p className="font-medium text-gray-700 group-hover:text-orange-600">List Users</p>
                      <p className="text-sm text-gray-500 mt-1">View and manage all users</p>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UserSettings;
